import { memo } from "react";

import { type TTailwindString, tw } from "classnames";

type Props = { count: number };

const styles = {
  section: tw(
    "mt-6",
    "border-0",
    "border-t",
    "border-solid",
    "border-divider",
    "pt-6"
  ),
  heading: tw(
    "mb-2",
    "h-5",
    "w-full",
    "max-w-[120px]" as TTailwindString,
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  products: tw("flex", "flex-col", "gap-4"),
  card: tw(
    "box-border",
    "flex",
    "min-h-[96px]" as TTailwindString,
    "items-center",
    "overflow-hidden",
    "rounded",
    "border-2",
    "border-solid",
    "border-placeholder",
    "bg-background-primary-muted",
    "p-px",
    "md:min-h-[104px]" as TTailwindString
  ),
  checkbox: tw("shrink-0", "p-4", "md:p-6"),
  checkboxShape: tw(
    "h-6",
    "w-6",
    "animate-pulse",
    "rounded",
    "border",
    "border-solid",
    "border-placeholder",
    "bg-placeholder"
  ),
  copy: tw("flex", "min-w-0", "flex-1", "flex-col", "gap-2", "py-4"),
  title: tw(
    "h-4",
    "w-full",
    "max-w-[160px]" as TTailwindString,
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  price: tw(
    "h-3",
    "w-full",
    "max-w-[60px]" as TTailwindString,
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  image: tw(
    "my-2",
    "mr-2",
    "h-16",
    "w-16",
    "shrink-0",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "md:h-22",
    "md:w-22"
  ),
};

const AddonUpsellPlaceholderBase = ({ count }: Props) => (
  <section
    aria-hidden="true"
    className={styles.section}
    data-placeholder-region="component"
  >
    <div className={styles.heading}></div>
    <div className={styles.products}>
      {Array.from({ length: count }, (_, index) => (
        <div
          className={styles.card}
          data-addon-placeholder-card
          key={`addon-placeholder-${index}`}
        >
          <div className={styles.checkbox}>
            <div className={styles.checkboxShape}></div>
          </div>
          <div className={styles.copy}>
            <div className={styles.title}></div>
            <div className={styles.price}></div>
          </div>
          <div className={styles.image}></div>
        </div>
      ))}
    </div>
  </section>
);

export const AddonUpsellPlaceholder = memo(AddonUpsellPlaceholderBase);
